"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDesignDefectItem = exports.isOperationDefect = exports.isAbleToClose = exports.isAlreadyClose = exports.isAbleToDefect = exports.getPeriod = exports.isEvaluationData = exports.isDesignEvaluation = exports.isOperationEvaluation = exports.isTableContent = exports.isEvaluationFile = exports.isOperationWeakStateItem = exports.JudgementLevel = exports.Result = exports.EVIDENCE_KEY = exports.DesignWeakState = exports.OperationWeakState = exports.ResultState = exports.ProgressState = exports.EvaluationState = exports.getKoEvaluation = exports.Type = exports.BASE_ITEM = void 0;
/* eslint-disable no-redeclare */
/* eslint-disable camelcase */
var lodash_1 = __importDefault(require("lodash"));
exports.BASE_ITEM = '__new__';
exports.Type = {
    Operation: 'operation',
    Design: 'design'
};
function getKoEvaluation(type) {
    return type === exports.Type.Design ? '설계평가' : '운영평가';
}
exports.getKoEvaluation = getKoEvaluation;
exports.EvaluationState = {
    Progress: '1',
    Closed: '2'
};
exports.ProgressState = {
    // "1": 미수행 "2": 수행중 "3": 수행완료 "4": 재작성필요 "5": 승인완료 "6": 수행 요청
    Unperformed: '1',
    Performing: '2',
    Performed: '3',
    Rejected: '4',
    Approved: '5',
    // Only use for frontend
    Request: '6',
    Exported: '7'
};
exports.ResultState = {
    // - 운영평가
    //   "1": default. 생성 시 상태
    //   "2": 문제 없음. 특이사항 없음
    //   "3": 문제 있음. 예외사항 발생
    // - 설계평가
    //   "1": default. 생성 시 상태
    //   "2": 문제 없음. Effective
    //   "3": 문제 있음. Ineffective
    Default: '1',
    Normal: '2',
    Defect: '3'
};
exports.OperationWeakState = {
    //   "1": default
    //   "2": 평가대기중
    //   "3": 단순한 미비점
    //   "4": 유의한 미비점
    //   "5": 중요한 취약점
    Default: '1',
    Pending: '2',
    Deficiency: '3',
    SignificantDeficiency: '4',
    MaterialWeakness: '5'
};
exports.DesignWeakState = {
    //   "1": default(생성시 들어가는 상태, reset 시)
    //   "2": 평가대기중
    //   "3": 작성완료 (반영할 수정사항 없음)
    //   "4": 작성완료 (반영할 수정사항 있음)
    Default: '1',
    Pending: '2',
    Done: '3',
    Modification: '4'
};
exports.EVIDENCE_KEY = '증빙자료 Ref';
exports.Result = {
    ineffective: 'Ineffective',
    effective: 'Effective'
};
exports.JudgementLevel = {
    low: '낮은 수준',
    high: '높은 수준'
};
function isOperationWeakStateItem(value) {
    return lodash_1.default.every((0, lodash_1.default)(value)
        .keys()
        .map(function (k) { return lodash_1.default.includes(['answer', 'reason', 'question'], k); })
        .value());
}
exports.isOperationWeakStateItem = isOperationWeakStateItem;
function isEvaluationFile(value) {
    return lodash_1.default.get(value, 'excelData');
}
exports.isEvaluationFile = isEvaluationFile;
function isTableContent(value) {
    return lodash_1.default.every(lodash_1.default.map(lodash_1.default.keys(value), function (k) {
        return lodash_1.default.includes(['headerRow', 'columnCountIncludingNumbering', 'rowCountExceptHeader', 'rowObjectList'], k);
    }));
}
exports.isTableContent = isTableContent;
function isOperationEvaluation(value) {
    return value.type === exports.Type.Operation;
}
exports.isOperationEvaluation = isOperationEvaluation;
function isDesignEvaluation(value) {
    return value.type === exports.Type.Design;
}
exports.isDesignEvaluation = isDesignEvaluation;
function isEvaluationData(value) {
    if (!value || isTableContent(value)) {
        return false;
    }
    return lodash_1.default.has(value, 'type') && lodash_1.default.includes([exports.Type.Operation, exports.Type.Design], lodash_1.default.get(value, 'type'));
}
exports.isEvaluationData = isEvaluationData;
function getPeriod(base) {
    if (lodash_1.default.isEmpty(base.startDate) || lodash_1.default.isEmpty(base.endDate)) {
        return '';
    }
    return "".concat(base.startDate, " ~ ").concat(base.endDate);
}
exports.getPeriod = getPeriod;
function isAbleToDefect(evaluation) {
    return (evaluation.state.state === exports.ProgressState.Approved &&
        evaluation.state.resultState === exports.ResultState.Defect &&
        evaluation.base.state === exports.EvaluationState.Progress);
}
exports.isAbleToDefect = isAbleToDefect;
function isAlreadyClose(evaluations) {
    return lodash_1.default.some(evaluations, function (evaluation) { return evaluation.base.state === exports.EvaluationState.Closed; });
}
exports.isAlreadyClose = isAlreadyClose;
function isAbleToClose(evaluations) {
    return lodash_1.default.every(evaluations, function (evaluation) {
        if (evaluation.base.state === exports.EvaluationState.Closed) {
            // 이미 마감된 평가일 경우
            return false;
        }
        if (evaluation.state.state !== exports.ProgressState.Approved) {
            // 미승인된 통제일 경우
            return false;
        }
        if (evaluation.state.resultState === exports.ResultState.Normal) {
            // 통제 평가 완료 후, 문제가 없는 경우
            return true;
        }
        if (evaluation.state.resultState === exports.ResultState.Defect &&
            !lodash_1.default.includes([exports.OperationWeakState.Default, exports.OperationWeakState.Pending], evaluation.state.weakState)) {
            // 문제가 있는 평가에 대해 미비점 평가를 완료한 경우
            return true;
        }
        return false;
    });
}
exports.isAbleToClose = isAbleToClose;
function isOperationDefect(value) {
    return (lodash_1.default.has(value, '1') &&
        lodash_1.default.has(value, '2') &&
        lodash_1.default.has(value, '3') &&
        lodash_1.default.has(value, '4') &&
        lodash_1.default.has(value, '5'));
}
exports.isOperationDefect = isOperationDefect;
function isDesignDefectItem(value) {
    return lodash_1.default.has(value, 'content') && lodash_1.default.has(value, 'evidence');
}
exports.isDesignDefectItem = isDesignDefectItem;
//# sourceMappingURL=Evaluation.js.map